'use client';

import { Button, Link } from '@radix-ui/themes';
import { Responsive } from '@radix-ui/themes/dist/esm/props/prop-def.js';

// TODO: add color as a prop and pass it through
type ButtonLinkProps = {
  href: string;
  text: string;
  variant: 'classic' | 'solid' | 'surface' | 'outline' | 'ghost';
  size: Responsive<'1' | '2' | '3' | '4'>;
};

export default function ButtonLink({ variant, size, href, text }: ButtonLinkProps) {
  return (
    <Button variant={variant} size={size} asChild>
      <Link href={href}>{text}</Link>
    </Button>
  );
}
